import React, {useEffect, useMemo, useState} from 'react';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import {Col} from 'react-bootstrap';
import {
  FONT_PICKER_DEFAULT_FONTS,
  FontOption,
  FontPicker,
} from '@pulsoid-private/widgets-lib';
import {FontUploadModal} from './FontUploadModal/FontUploadModal';
import {usePulsoidClient} from '../../PulsoidClient';

export type NewFontManagerProps = {
  font: string | FontOption;
  fontUrl?: string;
  onChange: (font: string | FontOption) => void;
  as?: typeof Row | typeof Col;
  className?: string;

  withUpload?: boolean;
  // onUpload?: (font: {name: string; file: File}) => void;
};

const filterUserFontsFromUploads = (
  files: {
    addedAt: string;
    id: string;
    name: string;
    type: string;
    url: string;
  }[]
): FontOption[] => {
  const uniqueFontNames = new Set();

  const fonts = files
    .filter((file) => file.type === 'Font')
    .filter((file) => {
      if (uniqueFontNames.has(file.name)) {
        return false;
      }
      uniqueFontNames.add(file.name);
      return true;
    })
    .map((file) => ({
      name: file.name,
      url: file.url,
    }));

  return fonts;
};

export const NewFontManager = (props: NewFontManagerProps) => {
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [userFonts, setUserFonts] = useState<FontOption[]>([]);
  const pulsoidClient = usePulsoidClient();

  const fontUrl =
    typeof props.font === 'object' ? props.font.url : props.fontUrl;
  const fontName =
    typeof props.font === 'object' ? props.font.name : props.font;

  const selectedFont = React.useMemo(
    () =>
      typeof props.font === 'object'
        ? props.font
        : ({name: fontName, url: fontUrl as string} as FontOption),
    [props.font, fontName, fontUrl]
  );
  const fonts = useMemo(
    () => [...userFonts, ...FONT_PICKER_DEFAULT_FONTS],
    [userFonts]
  );

  useEffect(() => {
    const fetchUserFonts = async () => {
      try {
        const {files} = await pulsoidClient.getGallery();
        const fonts = filterUserFontsFromUploads(files);
        setUserFonts(fonts);
      } catch (e) {
        // Custom fonts are not available
        // Do nothing
        setUserFonts([]);
        console.error('Custom fonts are not available', e);
      }
    };

    if (props.withUpload) {
      fetchUserFonts();
    }
  }, []);

  const uploadFileToPulsoid = async ({
    file,
    name,
  }: {
    file: File;
    name: string;
  }) => {
    try {
      const fileUrl = await pulsoidClient.uploadFile(file);
      const addFileRes = await pulsoidClient.addFileToGallery(
        name,
        fileUrl,
        'Font'
      );

      const newFonts = filterUserFontsFromUploads(addFileRes?.files);

      setUserFonts(newFonts);
      const selectedFont = newFonts.find((font) => font.name === name);
      if (selectedFont) {
        props.onChange({name: selectedFont.name, url: selectedFont.url});
      }
    } catch (e) {
      // TODO: Handle error
      console.error('Error while uploading file to Pulsoid', e);

      throw e;
    }
  };

  return (
    <>
      <FontUploadModal
        show={showUploadModal}
        onClose={() => setShowUploadModal(false)}
        onSubmit={uploadFileToPulsoid}
      />

      <Form.Group as={props.as || Row} className={props?.className}>
        <Form.Label column sm="2">
          Font
        </Form.Label>

        <Col sm="6">
          <Row>
            <Col sm="6">
              <FontPicker
                selectedFont={selectedFont}
                onFontChange={props.onChange}
                withUpload={props.withUpload}
                onFontUploadClick={() => setShowUploadModal(true)}
                fonts={fonts}
              />
            </Col>
            <p
              className="apply-font align-self-center flex"
              style={{
                paddingLeft: '20px',
                height: '100%',
                fontFamily: `"${fontName}"`,
                margin: '0 0 2px 0',
              }}
            >
              1234567890
            </p>
          </Row>
        </Col>
      </Form.Group>
    </>
  );
};
